export default "__VITE_PUBLIC_ASSET__41f68ac4__"